import { render, staticRenderFns } from "./AlertVModelSupport.vue?vue&type=template&id=708afc70&"
import script from "./AlertVModelSupport.vue?vue&type=script&lang=js&"
export * from "./AlertVModelSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports